import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faEye } from "@fortawesome/free-regular-svg-icons"

export const EyeRegular = (props) => {
  return <FontAwesomeIcon faIcon={faEye} {...props} />
}
